import React from "react";
import video from "../assets/video/1600X650-peru.mp4";
import gif1 from "../assets/img/Image1.gif";
import gif2 from "../assets/img/Image2.gif";
import gif3 from "../assets/img/Image3.gif";
import fondoazul2 from "../assets/img/fondoazul2.gif";
import correct2 from "../assets/img/correct2.gif";
import fondoazul3 from "../assets/img/fondoazul3.gif";
import FormularioWeb from "../components/FormularioWeb";
import Footer from "../components/Footer";
import CounterUpNumeros from "../components/CounterUpNumeros";
import Sucursales from "../components/Sucursales";
import { NavLink } from "react-router-dom";

function Home() {
  return (
    <div>
      <div className="banner">
        <video autoPlay loop muted className="video-banner">
          <source src={video} type="video/mp4" />
        </video>
        <div className="banner-text">
          <div>
            <span className="arte">EL ARTE DE </span>
          </div>
          <div>
            <span className="acelerar">ACELERAR </span>{" "}
            <span className="arte">EL </span>
            <span className="tiempo">TIEMPO</span>
          </div>
          <div>
            <span className="consigue">Consigue</span>
            <span className="liquidez"> liquidez inmediata</span>
          </div>
          <div>
            <span className="consigue"> y sigue adelante con tu </span>
            <span className="liquidez">negocio</span>
          </div>
          <div>
            <span className="factoring">
              Factoring • Factoring Internacional
            </span>
          </div>
        </div>
      </div>
      <div className="titulo-descripcion">
        <h2>Líderes en el mercado del factoring</h2>
        <p className="descripcion">
          Contamos con una diversidad de productos y la orientación financiera
          apropiada. De esa forma hemos acompañado a nuestros clientes,
          otorgándoles el capital de trabajo que les ha dado el respaldo para el
          éxito de sus negocios.
        </p>
      </div>
      <div className="info-cuadro">
        <div className="row">
          <div className="col-md-4">
            <div className="card sin-borde">
              <div className="card-body">
                <img
                  src={gif1}
                  className="card-img-top gifInicio"
                  alt="Imagen 1"
                />
                <h4>Factoring y descuento de documentos</h4>
                <p className="card-text">
                  Creamos financiamientos a la medida a través del descuento de
                  facturas y documentos de contenido crediticio.
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card sin-borde">
              <div className="card-body">
                <img
                  src={gif2}
                  className="card-img-top gifInicio"
                  alt="Imagen 2"
                />
                <h4>Cobranza Externa</h4>
                <p className="card-text">
                  Hacemos la gestión de cobro y custodia con óptimos resultados
                  en la recuperación de flujos.
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card sin-borde">
              <div className="card-body">
                <img
                  src={gif3}
                  className="card-img-top gifInicio"
                  alt="Imagen 3"
                />
                <h4>Orientación Financiera</h4>
                <p className="card-text">
                  Asesoramos a nuestros clientes para garantizarles las mejores
                  alternativas de financiamiento.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="text-center">
          <NavLink to="/ProductosYServicios" className="btn btn-custom">
            Saber más
          </NavLink>
        </div>
      </div>

      {/* Por qué elegir PRIMUS */}
      <div className="full-width-box">
        <div className="inner-box">
          <h1>¿Por qué elegir Primus Capital?</h1>
          <div className="descripcionElegir">
            <p>
              La mayor garantía se respalda en la confianza de los clientes que
              han contado con nuestro apoyo financiero de forma ágil y oportuna,
              a través de una excelente gestión de profesionales con años de
              experiencia en el negocio.
            </p>
          </div>
          <h2>La fórmula que nos distingue es:</h2>

          <div className="gif-container">
            <div className="gif-box">
              <img src={fondoazul2} alt="Atención de primera" />{" "}
              <p>Atención de primera</p>
            </div>
            <div className="gif-box">
              <img src={correct2} alt="Agilidad y seguridad" />{" "}
              <p>Agilidad y seguridad</p>
            </div>
            <div className="gif-box">
              <img src={fondoazul3} alt="Tecnología de vanguardia" />
              <p>Tecnología de vanguardia</p>
            </div>
          </div>
        </div>
      </div>
      {/* Cuadro números */}
      <div className="divTitleMirada">
        <h1 className="titleMirada">Primus Capital en una mirada</h1>
      </div>

      <CounterUpNumeros />
      <div className="formulario">
        <h2>¿Tienes facturas pendientes de cobro?</h2>
        <FormularioWeb />
      </div>
      <Sucursales />      
    <div className="fondo-redes">
      <h1 className="titulo-redes">Síguenos en nuestras redes</h1>
      <div className="footer-social">
        <a
          href="https://www.facebook.com/primuscapitalperu/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fab fa-facebook"></i>
        </a>
        <a
          href="https://www.instagram.com/primuscapitalperu/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fab fa-instagram"></i>
        </a>
        <a
          href="https://cl.linkedin.com/company/primus-capital-peru"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fab fa-linkedin"></i>
        </a>
      </div>
    </div>
  

      <Footer />
    </div>
  );
}

export default Home;
